import {InjectionToken} from "@angular/core";
import {ILanguageResolverService} from "./iLanguageResolverService";

export const languageResolverServiceInjectionToken: InjectionToken<ILanguageResolverService> = new InjectionToken<ILanguageResolverService>("digital-signage-user-dashboard-web.LanguageResolverService");
